<template>
  <div style="padding: 20px">
    <WmsTable
        :columns="detailColumns"
        :dataSource="detail"
        :isPagination="false"
      >
        <div slot="print" slot-scope="{record}">
          <el-input maxlength='450' v-model="record.printNum"></el-input>
        </div>
        <div slot="action">
          <a @click="print">打印</a>
        </div>
      </WmsTable>
    <el-button
      @click="close"
      type="primary"
      style="float: right; margin-top: 10px"
      >确定</el-button
    >
  </div>
</template>

<script>
import WmsTable from "@/components/WmsTable";
import ImgPreviews from "@/components/ImgPreviews";
import { combinColumns, goodsColumns, detailColumns } from "./combinTable";
export default {
  name: "detail",
  components: { WmsTable, ImgPreviews },
  data() {
    return {
      detailColumns,
      detail: [],
      formInline: {
        remark: "",
      },
      query: {
        current: 1,
        pageNum: 99,
      },
    };
  },
  mounted() {},
  methods: {
    print() {
      this.$message.warning("开发中");
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.abnormalImage {
  display: flex;
}
</style>
